import * as UTIF from 'utif';

export const convertToTiff = async ({ base64Tiff }) => {
  const tiffBase64 = base64Tiff.split(',')[1]; // Remove the Base64 header.
  const tiffData: Uint8Array<ArrayBuffer> = Uint8Array.from(atob(tiffBase64), (c) => c.charCodeAt(0)); // Decode Base64 to binary.

  const ifds = UTIF.decode(tiffData as unknown as ArrayBuffer);
  UTIF.decodeImage(tiffData as unknown as ArrayBuffer, ifds[0]);
  const rgba = UTIF.toRGBA8(ifds[0]);

  if (!ifds[0]?.width || !ifds[0]?.height) {
    return;
  }
  const canvas = new OffscreenCanvas(ifds[0].width, ifds[0].height);
  const ctx = canvas.getContext('2d');

  const imageData = ctx?.createImageData(ifds[0].width, ifds[0].height);
  imageData?.data.set(rgba);
  if (!imageData) {
    return;
  }
  ctx?.putImageData(imageData, 0, 0);

  const blob = await canvas.convertToBlob({ type: 'image/png' });
  const reader = new FileReader();
  return new Promise((resolve) => {
    reader.onload = () => {
      const base64Png = reader.result;
      resolve(base64Png);
    };
    reader.readAsDataURL(blob);
  });
};
